import React from 'react';
import '../../FiltersBar.css';

const FiltersBarNotification = (props) => {
  return (
    <div className="FiltersBar_Notification">
      <div className="FiltersBar_Notification_Triangle"></div>
      <div className="FiltersBar_Notification_Box">{props.notification}</div>
    </div>
  );
};

export default FiltersBarNotification;
